export const USER_AND_PERMISSIONS_EVENTS = {
  PAGE_VIEWED: "Users & Permissions Viewed",
  INVITE_USER_STARTED: "User Invite Started",
  INVITE_USER_SUBMITTED: "User Invite Submitted",
  USER_ROLE_CHANGED: "User Role Changed"
};

export const USER_AND_PERMISSIONS_EVENTS_PARAMS = {
  ROLE: "role",
  INVITATION_SURFACE: "invite_surface",
  INVITED_ROLE: "invited_role",
  INVITE_CHANNEL: "invite_channel",
  RESULT: "result",
  FAILURE_REASON: "failure_reason",
  TARGET_USER_ID: "target_user_id",
  FROM_ROLE: "from_role",
  TO_ROLE: "to_role",
};

export const USER_AND_PERMISSIONS_EVENTS_VALUES = {
  MODAL: "modal",
  EMAIL: "email",
  PHONE: "phone",
  ACTIVE: "active",
  EXPIRED: "expired",
  MERCHANT: "merchant",
};